// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column" style="float: none">
    <form-section form-title="'Automatic debit agreement'">
      <form-section-field field-title="'Allow automatic debit?'">
        <select
          ng-model="\$ctrl.accountType.automaticDebitAgreementEnabled"
          ng-change="\$ctrl.onEnabledChange()"
          required
          boolean-options>
        </select>
      </form-section-field>

      <form-section-field field-title="'Allow auto creation'" ng-if="\$ctrl.accountType.automaticDebitAgreementEnabled">
        <select
          ng-model="\$ctrl.allowAutoCreation"
          ng-change="\$ctrl.onAutoCreationChange()"
          required
          boolean-options>
        </select>
      </form-section-field>
    </form-section>
  </div>

  <div ng-if="\$ctrl.allowAutoCreation">
    <div class="form-column" style="float: none">
      <form-section form-title="'Automatic creation hierarchy'">
        <form-section-field field-title="'Automatic debit schedule'">
          <select
            ng-model="\$ctrl.accountType.automaticDebitAgreementConfig.schedule"
            ng-options="option.value as option.label for option in \$ctrl.automaticDebitScheduleOptions"
            required>
          </select>
        </form-section-field>
      </form-section>
    </div>

    <table class="table">
      <thead>
      <th>Order</th>
      <th>Product name</th>
      <th>Strategy</th>
      <th>Retain maintaining balance</th>
      <th>Execute on account credit for missed payments</th>
      <th>Action</th>
      </thead>
      <tbody>
      <tr ng-repeat="hierarchy in \$ctrl.accountType.automaticDebitAgreementConfig.hierarchies">
        <td>{{hierarchy.orderNo = \$index + 1}}</td>
        <td>
          <select
            ng-model="hierarchy.productDefinitionId"
            ng-options="pd.id as pd.productName for pd in \$ctrl.productDefinitions"
            required>
          </select>
        </td>
        <td>
          <select
            ng-model="hierarchy.strategy"
            ng-options="option.value as option.label for option in \$ctrl.automaticDebitStrategyOptions"
            required>
          </select>
        </td>
        <td>
          <select
            ng-model="hierarchy.keepMaintainingBalance"
            boolean-options
            required>
          </select>
        </td>
        <td>
          <select
            ng-model="hierarchy.executeOnAccountCredit"
            boolean-options
            required>
          </select>
        </td>
        <td>
          <button
            class="btn icon-chevron-up"
            ng-click="\$ctrl.moveUpHierarchy(\$index)"
            ng-disabled="\$index === 0">
          </button>
          <button
            class="btn icon-chevron-down"
            ng-click="\$ctrl.moveDownHierarchy(\$index)"
            ng-disabled="\$index === \$ctrl.accountType.automaticDebitAgreementConfig.hierarchies.length - 1">
          </button>
          <button
            class="btn btn-danger"
            ng-click="\$ctrl.removeHierarchy(\$index)"
            ng-disabled="\$ctrl.accountType.automaticDebitAgreementConfig.hierarchies.length === 1">
            Remove
          </button>
        </td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <button class="btn btn-primary" ng-click="\$ctrl.addHierarchy()">Add</button>
        </td>
      </tr>
      </tbody>
    </table>
    <validator condition="\$ctrl.accountType.automaticDebitAgreementConfig.hierarchies.length > 0"></validator>
  </div>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/ada/deposit-account-ada-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;